// this comes from the DS and cannot be changed
export const MAX_AUTO_COMPLETE_OPTIONS = 5
